import { DocumentSection } from '@/shared/api/transcriptor/transcriptorApi';

import { getDocumentSectionContent } from '../../lib/getDocumentSectionContent';

export type DocumentRenderItem =
  | { category: string; kind: 'group'; sections: DocumentSection[] }
  | { kind: 'standalone'; section: DocumentSection };

const hasContent = (section: DocumentSection): boolean =>
  Boolean(getDocumentSectionContent(section));

const appendGroupedSection = (
  items: DocumentRenderItem[],
  category: string,
  section: DocumentSection,
): DocumentRenderItem[] => {
  const lastItem = items[items.length - 1];

  if (lastItem?.kind === 'group' && lastItem.category === category) {
    return [
      ...items.slice(0, -1),
      {
        ...lastItem,
        sections: [...lastItem.sections, section],
      },
    ];
  }

  return [...items, { category, kind: 'group', sections: [section] }];
};

export const buildDocumentRenderItems = (
  sections: DocumentSection[],
): DocumentRenderItem[] =>
  sections.filter(hasContent).reduce<DocumentRenderItem[]>((items, section) => {
    const category = section.category?.trim();

    if (!category) {
      return [...items, { kind: 'standalone', section }];
    }

    return appendGroupedSection(items, category, section);
  }, []);
